import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon__vip_logo@2x.png'
import _imports_1 from '@/assets/image/vipImg/icon_tab_vip@2x.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "vip-logo"
}, null, -1)
const _hoisted_3 = { class: "membership-center" }
const _hoisted_4 = { class: "memberLevel-popver" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "valid-time" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "vip-logo"
}, null, -1)
const _hoisted_9 = { class: "membership-center" }
const _hoisted_10 = { class: "wrap" }
const _hoisted_11 = {
  class: "tag",
  style: {"width":"120px"}
}
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "content-c" }
const _hoisted_14 = { class: "member-status" }
const _hoisted_15 = { class: "tips" }
const _hoisted_16 = {
  key: 0,
  class: "explain mt_15"
}
const _hoisted_17 = { style: {"padding":"0 !important"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_19 = { class: "text" }
const _hoisted_20 = {
  key: 1,
  class: "member_content"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/member/member_true.png",
  alt: ""
}, null, -1)
const _hoisted_22 = { class: "title" }

import { reactive, ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRtfix, useSite2Station, isJA, isKO, isEN, useSite } from '@/store'
import { t } from '@/plugins/i18n'
import { isFirstPayVipApi } from '@/apis/usercenter'
import { Site } from '@/common/const'
import { getCurrentMonetaryUnit, getActivePriceByStation } from '@/util/useYan'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const membership = computed(() => {
  return store.getters.membership
})
const onlyOpenSpecail = computed(() => store.getters.onlyOpenSpecail)
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

const vipClick = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'member'
    }
  })
  if (!store.getters.isLogin) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        source: 'member',
        position: 'login'
      }
    })
  }
}
// const membership = store.getters.membership // 会员信息
const isSub = store.getters.isSub
// templateLevel //  0：非会员; 1:白金舱...
const effectList = ref([
  // 功能列表
  {
    id: 1,
    text: t('能够在中国找到丰富的供应商')
  },
  {
    id: 2,
    text: t('按照日本质量标准进行检验（隶属于日本公司）')
  },
  {
    id: 3,
    text: t('最低国际运费保证，可运往23个国家/地区')
  },
  {
    id: 4,
    text: t('可靠的支持和即时的客户服务')
  }
])

const jaList = [
  {
    title: t('EC 网站商品采购'),
    tag: '无限制'
  }, {
    title: t('类似图片搜索'),
    tag: '无限制'
  }, {
    title: t('日本标准质检')
  }, {
    title: t('品牌代理销售权')
  }, {
    title: t('与日本 EC 网站系统联动和代发货服务')
  }, {
    title: t('自定义选项和材料使用')
  }, {
    title: t('简单 OEM 支持')
  }, {
    title: t('系统聊天支持')
  }
]

const countryCurrency = getCurrentMonetaryUnit() // 站点的货币符号

const getActivityVipImage = () => {
  if (isJA()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/active_member_pop.png'
  } else if (isKO()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/vip_pop_ko1.png'
  } else {
    return 'https://static-s.theckb.com/BusinessMarket/member/tabbar_pop_up_background_en.png'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_unref(membership).templateLevel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_popover, {
          ref: (_value, _refs) => {
            _refs['popoverRef'] = _value
          },
          trigger: "hover",
          width: "300px",
          "popper-class": _unref(membership).templateLevel === 1
      ? 'popver-bg1'
      : _unref(membership).templateLevel === 2
        ? 'popver-bg2'
        : _unref(membership).templateLevel === 3
          ? 'popver-bg3'
          : _unref(membership).templateLevel === 4 ?
            'popver-bg4' : 'popver-bg5'
      
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", {
              class: "ml_30 point",
              onClick: vipClick
            }, [
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel'),
                class: "light"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('会员中心')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass({ trialTag: _unref(membership).trialFlag, tag: !_unref(membership).trialFlag, isSpecial: _unref(membership).templateLevel === 5 })
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(membership).trialFlag ? (_unref(membership).templateLevel === 5 ? _unref(t)('特惠体验中') : _unref(t)('试用')) :
            _unref(t)('我的会员')), 1)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(`content-c ${_unref(membership).templateLevel === 5 ? 'isSpecial' : ''}`)
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(["member-level", _unref(useSite)()])
                }, _toDisplayString(_unref(membership).membershipTemplateName), 3),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('有效期：')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(membership).expiresDate), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: _unref(useRtfix)('VipLevel')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: _normalizeClass(["btn mt_10", _unref(membership).templateLevel === 1
              ? 'btn-c1'
              : _unref(membership).templateLevel === 2
                ? 'btn-c2'
                : _unref(membership).templateLevel === 3
                  ? 'btn-c3'
                  : _unref(membership).templateLevel === 4 ?
                    'btn-c4' : 'btn-c5'
              ])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('去续费')), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["popper-class"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_el_popover, {
          ref: (_value, _refs) => {
            _refs['popoverRef'] = _value
          },
          trigger: "hover",
          width: "300px",
          "popper-class": 'memberExpire-popver memberExpire-popver-' + _unref(useSite)()
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", {
              class: "ml_30 point",
              onClick: vipClick
            }, [
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('VipLevel'),
                class: "light"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('会员中心')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('当前等级')), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h3", _hoisted_14, _toDisplayString(_unref(t)('免费会员')), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)('入会优享超多服务')), 1),
                (!_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("ul", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectList.value, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.id,
                            class: "list flex ter"
                          }, [
                            _hoisted_18,
                            _createElementVNode("p", _hoisted_19, _toDisplayString(item.text), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jaList, (item, idx) => {
                        return _createElementVNode("div", {
                          class: "member_content_item",
                          key: idx
                        }, [
                          (item.title)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1),
                                (item.tag)
                                  ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "tags"
                                    }, _toDisplayString(_unref(t)(item.tag)), 513)), [
                                      [_vShow, _unref(t)(item.tag)]
                                    ])
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      }), 64))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: _unref(useRtfix)('VipLevel')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { class: "btn" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(isSub) ? _unref(t)('查看会员') : _unref(t)('开通会员')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popper-class"])
      ]))
}
}

})